<script setup lang="ts">
const { t } = useI18n({ useScope: 'global' })

defineProps<{
  leftDisabled?: boolean
  rightDisabled?: boolean
}>()

const emit = defineEmits<{
  navigate: [direction: 'left' | 'right']
}>()
</script>

<template>
  <div class="flex items-center gap-s" data-testid="call-details-navigation">
    <OButton
      variant="tertiary"
      size="M"
      rounded-full
      :disabled="leftDisabled"
      :aria-label="t('call_details_navigation.previous')"
      data-testid="call-details-previous"
      @click="emit('navigate', 'left')"
    >
      <template #icon>
        <UiIcon
          name="arrow-left"
          variant="outline"
          size="s"
          class="text-neutral-1 group-disabled:text-primary-disabled"
        />
      </template>
    </OButton>

    <OButton
      variant="tertiary"
      size="M"
      rounded-full
      :disabled="rightDisabled"
      :aria-label="t('call_details_navigation.next')"
      data-testid="call-details-next"
      @click="emit('navigate', 'right')"
    >
      <template #icon>
        <UiIcon
          name="arrow-right"
          variant="outline"
          size="s"
          class="text-neutral-1 group-disabled:text-primary-disabled"
        />
      </template>
    </OButton>
  </div>
</template>
